module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-9-16044bebe6d8fa3b2db776a5b946c117.jpg";